import * as React from 'react';
import '@/pages/containers/auth/scss/form.scss';
import '../scss/index.scss';
import store from '@/redux/index';
import { types } from '@/redux/ui/address';
import alert from '@/pages/components/common/alert';
import request from '@/server/request';
import config from '@/server/config';

export default class StoreContactAdd extends React.Component <any, any>  {
	constructor(props: any) {
		super(props);
		const location = this.props.location;
		this.state = {
			companyId: location.state ? location.state.companyId : '', // 企业id
			id:  location.state ? location.state.id || '': '', // 联系人id
			type: location.state ? location.state.type || 2 : 2, // 类型 1-店铺联系人 2-销售联系人
			action: location.state ? location.state.action || '' : '',
			contact: '', // 联系人名称
			contact_tel: '', // 联系人电话
			fax: '', // 传真
			position: '',  // 职位
			mail: '', // 邮箱
			address: '', // 详细地址
			province: '',
			city: '',
			district: '',
			addressName: '',
		}
	}

	public componentDidMount() {
		if(this.state.action === 'edit') {
			this.initData();
		}
	}

	public render() {
		return (
			<div className="gray-bg">
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>联系人</label>
						<input
							type="text" 
							placeholder="请输入联系人名称" 
							className="text-right" 
							value={this.state.contact}  
							onChange={ (e:any) => this.changeState('contact', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>职务</label>
						<input
							type="text" 
							placeholder="请输入职务" 
							className="text-right" 
							value={this.state.position	}  
							onChange={ (e:any) => this.changeState('position', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>电话</label>
						<input
							type="text" 
							placeholder="请输入电话号码" 
							className="text-right" 
							value={this.state.contact_tel}  
							onChange={ (e:any) => this.changeState('contact_tel', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">传真</label>
						<input
							type="text" 
							placeholder="请输入传真" 
							className="text-right" 
							value={this.state.fax}  
							onChange={ (e:any) => this.changeState('fax', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">邮箱</label>
						<input
							type="text" 
							placeholder="请输入邮箱" 
							className="text-right" 
							value={this.state.mail}  
							onChange={ (e:any) => this.changeState('mail', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">公司地址</label>
						<button
							className="input-select text-right" 
							data-value={this.state.addressName}
							onClick={() => this.openAddressPanel()}
						>
							{ this.state.addressName || '请选择地址' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label"></label>
						<input
							type="text" 
							placeholder="请输入详细地址" 
							className="text-right" 
							value={this.state.address}  
							onChange={ (e:any) => this.changeState('address', e.target.value) }/>
						
					</div>
				</div>
				
				<div className="default-btn-warrper">
					<button className="default-btn" onClick={() => this.submitForm()}>保存</button>
					{
						this.state.action === 'edit' && this.state.type === 2 ? <button className="default-btn waring-btn" onClick={() => this.removeData() }>删除</button> : ''
					}
					{
						this.state.action === 'edit' && this.state.type === 1 ? <button className="default-btn waring-btn" onClick={() => this.goBack() }>返回</button> : ''
					}
				</div>
			</div>
		)
	}

	// 初始化
	private async initData() {
		const r = await request({
			method: "post",
			url: `${config.MALLAPI}api/shop/default/contact-details`,
			data: {
				companyId: this.state.companyId,
				id: this.state.id,
				type: this.state.type,
			}
		})

		if(r.error_code === 0) {
			this.setState({
				contact: r.data.contact || '', // 联系人名称
				contact_tel: r.data.contact_tel || '', // 联系人电话
				fax: r.data.fax || '', // 传真
				position: r.data.position || '',  // 职位
				mail: r.data.mail || '', // 邮箱
				address: r.data.address || '', // 详细地址
				province: r.data.province || '',
				city: r.data.city || '',
				district: r.data.district || '',
				addressName: r.data.province_str + r.data.city_str + r.data.district_str,
			})
		}
	}
	// 更新state
	private changeState(k: string, v: any) {
		this.setState({
			[k]: v
		})
	}

	private async submitForm() {
		if(!this.state.contact) {
			alert.open({
				promptText: '联系人不能为空！'
			})
			return ;
		}
		if(!this.state.position) {
			alert.open({
				promptText: '职务不能为空！'
			})
			return ;
		}
		if(!this.state.contact_tel) {
			alert.open({
				promptText: '电话号码不能为空！'
			})
			return ;
		}

		const r = await request({
			method: "post",
			url: `${config.MALLAPI}api/shop/default/contact-edit`,
			data: {
				companyId: this.state.companyId,
				id: this.state.id,
				type: this.state.type,
				contact: this.state.contact,
				contact_tel: this.state.contact_tel,
				fax: this.state.fax,
				position: this.state.position,
				mail: this.state.mail,
				address: this.state.address,
				province: this.state.province,
				city: this.state.city,
				district: this.state.district,
			}
		})

		if(r.error_code === 0) {
			alert.open({
				promptText: '提交成功！'
			})
			this.props.history.goBack(-1);
		}else {
			alert.open({
				promptText: r.msg
			})
		}
		// console.log(this.state)
	}

	// 删除数据
	private async removeData() {
		const r = await request({
			method: "post",
			url: `${config.MALLAPI}api/shop/default/contact-del`,
			data: {
				companyId: this.state.companyId,
				id: this.state.id,
			}
		})

		if(r.error_code === 0) {
			const that = this;
			alert.open({
				promptText: '删除成功！',
				callback: () => {
					(that.props as any).history.goBack(-1)	
				}
			});
			
		}
	}

	// 打开地址面板
    private openAddressPanel() {
        const that = this;
        store.dispatch({
            type: types.ADDRESS_SHOW,
            showData: {
                init: {
                	addressName: this.state.addressName,
                	province: this.state.province,
					city: this.state.city,
					district: this.state.district
                },
                onConfirm(r: any) {
                    that.setState({
						addressName: r.province.name + r.city.name + r.district.name,
						province: r.province.code.slice(0, 4),
						city: r.city.code.slice(0, 6),
						district: r.district.code
					})

                }
            }
        });
	}
	
	// 返回
	private goBack() { 
		this.props.history.goBack();
	}
}